export default __webpack_public_path__ + "static/havey-67b05f3233a98ecd6b0f01254e912c88.jpg";